import React from 'react';
import Myorders from '../../../Myorders/Myorders';

const DashboardHome = () => {
    return (
        <div>
            <Myorders></Myorders>
        </div>
    );
};

export default DashboardHome;